import { styled } from '@mui/material/styles';

export const VerifiedIcon = styled('i')({
  color: 'var(--success, #10b981)',
  fontSize: '1.5rem',
});

export const UnverifiedIcon = styled('i')({
  color: 'var(--error, #ef4444)',
  fontSize: '1.5rem',
});
